import React from 'react';

import { useIsNonInteractiveViewer } from '@app/ui';
import { useUserIsLoggedIn } from '@app/user';
import { EXPERIMENTS } from '@app/config';
import { useExperiment } from '@app/experiments';
import {
  SECTION_MY_ACCOUNT,
  SECTION_ABOUT,
  SECTION_ABOUT_EXTERNAL,
  SECTION_BROWSE,
  SECTION_HOW_IT_WORKS,
  SECTION_NEW_RELEASES,
  SECTION_NEWS,
  SECTION_POPULAR_BRANDS,
} from '@app/shell/SiteHeader/shared/consts/MobileNavigation';
import { SECTION_BROWSE_WITH_GENDER } from '@app/shell/SiteHeader/shared/consts/GenderNavigation';
import { MainMenuAnimationWrapper } from './MainMenu.styles';
import Footer from './components/Footer';
import MenuItem from './components/MenuItem';

type MainMenuProps = {
  isOpen: boolean;

  handleItemOnClick: (props) => void;
};

/**
 * Sections (Site)
 *  - Browse
 *  - About
 *  - How It Works
 *  - New Releases
 *  - Popular Brands
 *  - News
 *  - My Account (Logged in Only)
 *  - Footer (login / signup)
 *
 * Sections (External)
 * - Browse
 * - About (just a link)
 * - How it works (Just a link)
 * - Releases (just a link)
 * - footer (login / signup)
 *
 *
 * @param children
 * @param isOpen
 * @param handleItemOnClick
 * @constructor
 */
const MainMenu = ({ isOpen, handleItemOnClick }: MainMenuProps) => {
  const isNonInteractiveViewer = useIsNonInteractiveViewer();
  const isLoggedIn = useUserIsLoggedIn();
  const isWomensNavVariant =
    useExperiment(EXPERIMENTS.ab_home_add_womens_navigation_web) === 'variant';

  return (
    <MainMenuAnimationWrapper
      id="mobile-nav-main-menu"
      className={isOpen ? 'visible' : ''}
      key="menu"
    >
      {/* Browse */}
      <MenuItem
        key="browse-primary"
        onClick={handleItemOnClick}
        section={
          isWomensNavVariant ? SECTION_BROWSE_WITH_GENDER : SECTION_BROWSE
        }
        blogRender={isNonInteractiveViewer}
      />

      {/* About (Regular) */}
      {!isNonInteractiveViewer ? (
        <MenuItem
          key="about-primary"
          onClick={handleItemOnClick}
          section={SECTION_ABOUT}
          blogRender={isNonInteractiveViewer}
        />
      ) : null}

      {/* About (External + Bots) */}
      {isNonInteractiveViewer ? (
        <MenuItem
          key="about-external-primary"
          onClick={handleItemOnClick}
          section={SECTION_ABOUT_EXTERNAL}
          blogRender={isNonInteractiveViewer}
        />
      ) : null}

      {/* How It Works */}
      <MenuItem
        key="how-it-works-primary"
        onClick={handleItemOnClick}
        section={SECTION_HOW_IT_WORKS}
        blogRender={isNonInteractiveViewer}
      />

      {/* New Releases */}
      <MenuItem
        key="releases-primary"
        onClick={handleItemOnClick}
        section={SECTION_NEW_RELEASES}
        blogRender={isNonInteractiveViewer}
      />

      {/* Popular Brands */}
      {!isNonInteractiveViewer ? (
        <MenuItem
          key="brands-primary"
          onClick={handleItemOnClick}
          section={SECTION_POPULAR_BRANDS}
          blogRender={isNonInteractiveViewer}
        />
      ) : null}

      {/* News */}
      {!isNonInteractiveViewer ? (
        <MenuItem
          key="news-primary"
          onClick={handleItemOnClick}
          section={SECTION_NEWS}
          blogRender={isNonInteractiveViewer}
        />
      ) : null}

      {isLoggedIn ? (
        <MenuItem
          key="user-primary"
          onClick={handleItemOnClick}
          section={SECTION_MY_ACCOUNT}
          blogRender={isNonInteractiveViewer}
        />
      ) : null}
      <Footer />
    </MainMenuAnimationWrapper>
  );
};

export default MainMenu;
